import BaseViewController from "./base-view-controller";
import { formatPhone } from "../utils/prepare-submit";

class AuthorizedConsenterEditViewController extends BaseViewController {
  prepareSubmit(values) {
    if (values?.selectedData?.non_member_id) {
      values.non_member_id = values.selectedData.non_member_id;
    }
    values = formatPhone(values);
    return values;
  }
}

export default AuthorizedConsenterEditViewController;
